import _defineProperty from '@babel/runtime/helpers/defineProperty';
import { colors } from '../../constants/colors.js';
import { styles } from '../../constants/styles.js';
import { bottomSheetThemeNative } from '../../BottomSheet/theme.js';
import { buttonThemeWeb, buttonThemeNative, buttonDarkThemeWeb, buttonDarkThemNative } from '../../Button/theme.js';
import { buttonPillThemeWeb, buttonPillThemeNative } from '../../ButtonPill/theme.js';
import { fortumLogoThemeWeb } from '../../FortumLogo/theme.js';
import { iconButtonThemeNative } from '../../IconButton/theme.js';
import { inputFieldThemeWeb, inputFieldThemeNative } from '../../InputField/theme.js';
import { descriptionListThemeWeb } from '../../DescriptionList/theme.js';
import { checkboxThemeNative, checkboxThemeWeb } from '../../Checkbox/theme.js';
import { radioThemeNative, radioThemeWeb } from '../../Radio/theme.js';
import { accordionThemeNative, accordionThemeWeb } from '../../Accordion/theme.js';
import { selectThemeNative, selectThemeWeb } from '../../Select/theme.js';
import { chipsThemeNative, chipsThemeWeb } from '../../Chips/theme.js';
import { contentSwitcherThemeNative, contentSwitcherThemeWeb } from '../../ContentSwitcher/theme.js';
import { dotsThemeNative, dotsThemeWeb } from '../../Dots/theme.js';
import { errorMessageThemeNative, errorMessageThemeWeb } from '../../ErrorMessage/theme.js';
import { linkThemeWeb, linkThemeNative } from '../../Link/theme.js';
import { paginationThemeWeb, paginationThemeNative } from '../../Pagination/theme.js';
import { popoverThemeWeb } from '../../Popover/theme.js';
import { tableThemeWeb } from '../../Table/theme.js';
import { tabsThemeWeb, tabsThemeNative } from '../../Tabs/theme.js';
import { textAreaThemeWeb } from '../../Textarea/theme.js';
import { toggleThemeWeb, toggleThemeNative } from '../../Toggle/theme.js';
import { stepperThemeNative, stepperThemeWeb } from '../../Stepper/theme.js';
import 'styled-components';
import { sliderThemeNative, sliderThemeWeb } from '../../Slider/theme.js';
import { contextLinkThemeNative } from '../../ContextLink/theme.js';
import { headingThemeNative, headingThemeWeb } from '../../Heading/theme.js';
import { listItemsThemeWeb } from '../components/ListItems/theme.js';
import { linearProgressThemeWeb } from '../../LinearProgress/theme.js';
import { circularProgressThemeWeb } from '../../CircularProgress/theme.js';
import { multiselectThemeWeb } from '../../Multiselect/theme.js';
import { npsThemeWeb } from '../../NPS/theme.js';
import { contentTextThemeWeb, contentTextThemeNative } from '../../ContentText/theme.js';
import { datepickerThemeNative, datepickerThemeWeb } from '../../DatePicker/theme.js';
import { placeholderThemeWeb } from '../../Placeholder/theme.js';
import { sectionThemeWeb } from '../../Section/theme.js';
import { notificationThemeNative, notificationThemeWeb } from '../../Notification/theme.js';
import { searchThemeWeb } from '../../Search/theme.js';
import { fileUploadThemeWeb } from '../../FileUpload/theme.js';
import { dateBrowserThemeWeb, dateBrowserThemeNative } from '../../DateBrowser/theme.js';
import { menuThemeWeb } from '../../Menu/theme.js';
import { counterThemeWeb, counterThemeNative } from '../../Counter/theme.js';
import { progressThemeNative } from '../../Progress/theme.js';
import { px2rem } from '../helpers/style.js';
import { codeInputThemeNative } from '../../CodeInput/theme.js';
import { weekdayPickerThemeNative } from '../../WeekdayPicker/theme.js';
import { phoneInputThemeWeb } from '../../PhoneInput/theme.js';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), true).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var defaultThemeTokens = {
  brand: {
    logo: colors.ivyGreen900
  },
  background: {
    primary: 'background',
    secondary: colors.lightGrey
  },
  text: {
    link: 'info',
    primary: 'text',
    secondary: colors.sonicGrey,
    disabled: colors.fogGrey,
    desaturated: colors.snowWhite
  },
  button: {
    disabled: colors.cloudGrey,
    desaturated: colors.snowWhite
  },
  input: {
    background: 'background',
    disabled: colors.lightGrey,
    placeholder: colors.sonicGrey
  },
  border: {
    active: 'primary',
    inactive: colors.silverGrey,
    light: colors.cloudGrey,
    disabled: colors.fogGrey,
    desaturated: colors.snowWhite
  },
  focus: {
    primary: colors.cushyBlue,
    secondary: colors.snowWhite
  },
  label: {
    unfilled: 'text',
    filled: colors.emperorGrey,
    active: 'primary',
    disabled: colors.fogGrey,
    desaturated: colors.snowWhite
  },
  notification: {
    alert: {
      text: colors.powerRed700,
      background: colors.powerRed100
    },
    info: {
      text: colors.broadBlue900,
      background: colors.broadBlue100
    },
    primary: {
      text: colors.ivyGreen900,
      background: colors.ivyGreen100
    },
    warning: {
      text: colors.inkGrey,
      background: colors.electricYellow100
    }
  },
  widget: {
    control: 'background',
    disabled: colors.lightGrey,
    inactive: colors.sonicGrey,
    desaturated: colors.snowWhite
  }
};
var defaultTheme = {
  variant: 'normal',
  preferredComponentSize: 'l',
  headingScale: 'large',
  colors: {
    primary: colors.ivyGreen600,
    alert: colors.powerRed600,
    text: colors.inkGrey,
    info: colors.broadBlue700,
    background: colors.snowWhite
  },
  tokens: defaultThemeTokens,
  borders: {
    radius: px2rem(4)
  },
  focusIndicator: {
    opacity: 0.15
  },
  font: {
    family: styles.fontFamily.base,
    fontMapNative: {
      regular: 'FortumSansTT-Regular',
      regularItalic: 'FortumSansTT-RegularItalic',
      light: 'FortumSansTT-Light',
      lightItalic: 'FortumSansTT-LightItalic',
      bold: 'FortumSansTT-Bold',
      boldItalic: 'FortumSansTT-BoldItalic',
      medium: 'FortumSansTT-Medium',
      mediumItalic: 'FortumSansTT-MediumItalic'
    },
    "native": {
      maxScaleFactor: 0
    }
  },
  accordion: {
    "native": accordionThemeNative,
    web: accordionThemeWeb
  },
  bottomSheet: {
    web: null,
    "native": bottomSheetThemeNative
  },
  button: {
    web: buttonThemeWeb,
    "native": buttonThemeNative
  },
  buttonPill: {
    web: buttonPillThemeWeb,
    "native": buttonPillThemeNative
  },
  chips: {
    "native": chipsThemeNative,
    web: chipsThemeWeb
  },
  circularProgress: {
    web: circularProgressThemeWeb,
    "native": null
  },
  checkbox: {
    "native": checkboxThemeNative,
    web: checkboxThemeWeb
  },
  codeInput: {
    "native": codeInputThemeNative,
    web: null
  },
  contentSwitcher: {
    "native": contentSwitcherThemeNative,
    web: contentSwitcherThemeWeb
  },
  contentText: {
    web: contentTextThemeWeb,
    "native": contentTextThemeNative
  },
  contextLink: {
    web: null,
    "native": contextLinkThemeNative
  },
  counter: {
    web: counterThemeWeb,
    "native": counterThemeNative
  },
  datebrowser: {
    web: dateBrowserThemeWeb,
    "native": dateBrowserThemeNative
  },
  datepicker: {
    "native": datepickerThemeNative,
    web: datepickerThemeWeb
  },
  descriptionList: {
    "native": null,
    web: descriptionListThemeWeb
  },
  dots: {
    "native": dotsThemeNative,
    web: dotsThemeWeb
  },
  errorMessage: {
    "native": errorMessageThemeNative,
    web: errorMessageThemeWeb
  },
  fileUpload: {
    "native": null,
    web: fileUploadThemeWeb
  },
  fortumLogo: {
    "native": null,
    web: fortumLogoThemeWeb
  },
  heading: {
    "native": headingThemeNative,
    web: headingThemeWeb
  },
  iconButton: {
    web: null,
    "native": iconButtonThemeNative
  },
  inputField: {
    web: inputFieldThemeWeb,
    "native": inputFieldThemeNative
  },
  linearProgress: {
    web: linearProgressThemeWeb,
    "native": null
  },
  link: {
    web: linkThemeWeb,
    "native": linkThemeNative
  },
  listItems: {
    web: listItemsThemeWeb,
    "native": null
  },
  menu: {
    web: menuThemeWeb,
    "native": null
  },
  multiselect: {
    "native": null,
    web: multiselectThemeWeb
  },
  notification: {
    "native": notificationThemeNative,
    web: notificationThemeWeb
  },
  nps: {
    "native": null,
    web: npsThemeWeb
  },
  pagination: {
    web: paginationThemeWeb,
    "native": paginationThemeNative
  },
  phoneInput: {
    web: phoneInputThemeWeb,
    "native": null
  },
  placeholder: {
    "native": null,
    web: placeholderThemeWeb
  },
  popover: {
    web: popoverThemeWeb,
    "native": null
  },
  progress: {
    web: null,
    "native": progressThemeNative
  },
  radio: {
    "native": radioThemeNative,
    web: radioThemeWeb
  },
  search: {
    "native": null,
    web: searchThemeWeb
  },
  section: {
    "native": null,
    web: sectionThemeWeb
  },
  select: {
    "native": selectThemeNative,
    web: selectThemeWeb
  },
  slider: {
    "native": sliderThemeNative,
    web: sliderThemeWeb
  },
  stepper: {
    "native": stepperThemeNative,
    web: stepperThemeWeb
  },
  table: {
    "native": null,
    web: tableThemeWeb
  },
  tabs: {
    web: tabsThemeWeb,
    "native": tabsThemeNative
  },
  textarea: {
    web: textAreaThemeWeb,
    "native": null
  },
  toggle: {
    web: toggleThemeWeb,
    "native": toggleThemeNative
  },
  weekdayPicker: {
    web: null,
    "native": weekdayPickerThemeNative
  }
};

// istanbul ignore next
var condensedTheme = _objectSpread(_objectSpread({}, defaultTheme), {}, {
  preferredComponentSize: 's',
  variant: 'condensed'
});
var darkTheme = _objectSpread(_objectSpread({}, defaultTheme), {}, {
  focusIndicator: {
    opacity: 0.2
  },
  colors: {
    primary: colors.ivyGreen400,
    alert: colors.powerRed400,
    text: colors.cloudGrey,
    info: colors.broadBlue400,
    background: colors.professionalGrey
  },
  tokens: {
    brand: {
      logo: colors.poweringGreen500
    },
    background: {
      primary: 'background',
      secondary: colors.mineShaftGrey
    },
    text: {
      primary: 'text',
      link: 'info',
      disabled: colors.emperorGrey,
      secondary: colors.fogGrey,
      desaturated: colors.snowWhite
    },
    button: {
      disabled: colors.inkGrey,
      desaturated: colors.snowWhite
    },
    input: {
      background: 'background',
      disabled: colors.mineShaftGrey,
      placeholder: colors.sonicGrey
    },
    border: {
      active: 'primary',
      inactive: colors.sonicGrey,
      light: colors.emperorGrey,
      disabled: colors.emperorGrey,
      desaturated: colors.snowWhite
    },
    focus: {
      primary: colors.waterBlue,
      secondary: colors.raisinGrey
    },
    label: {
      unfilled: 'text',
      filled: colors.fogGrey,
      active: 'primary',
      disabled: colors.emperorGrey,
      desaturated: colors.snowWhite
    },
    notification: {
      alert: {
        text: colors.raisinGrey,
        background: colors.powerRed400
      },
      info: {
        text: colors.raisinGrey,
        background: colors.broadBlue400
      },
      primary: {
        text: colors.raisinGrey,
        background: colors.ivyGreen400
      },
      warning: {
        text: colors.raisinGrey,
        background: colors.electricYellow400
      }
    },
    widget: {
      control: 'background',
      disabled: 'background',
      inactive: colors.fogGrey,
      desaturated: colors.snowWhite
    }
  },
  button: {
    web: buttonDarkThemeWeb,
    "native": buttonDarkThemNative
  }
});

// istanbul ignore next
var darkCondensedTheme = _objectSpread(_objectSpread({}, darkTheme), {}, {
  variant: 'condensed'
});

// this adds the theme type to all styled() components
// https://styled-components.com/docs/api#create-a-declarations-file

export { condensedTheme, darkCondensedTheme, darkTheme, defaultTheme, defaultThemeTokens };
